import {clsx} from 'clsx'
import {useMemo} from 'react'

import {getIdeData} from './IdeList.data'
import IdeListItem, {type IdeListItemProps} from './IdeListItem/IdeListItem'

import Styles from './IdeList.module.css'

export interface IdeListProps {
  size?: IdeListItemProps['size']
  onItemClick?: (ideId: string, ideName: string) => void
  excludeList?: Array<IdeListItemProps['id']>
}

const defaultProps: Partial<IdeListProps> = {
  size: 'medium',
  excludeList: [],
}

const IdeList = (props: IdeListProps) => {
  const initializedProps: IdeListProps = {...defaultProps, ...props}
  const {size, onItemClick, excludeList} = initializedProps

  const items = useMemo(() => getIdeData(excludeList), [excludeList])

  return (
    <ul className={clsx(Styles['IdeList'], Styles[`IdeList--${size}` as keyof typeof Styles])}>
      {items.map(ide => (
        <IdeListItem key={ide.id} {...ide} size={size!} onClick={onItemClick} isListItem />
      ))}
    </ul>
  )
}

export default IdeList
